<div class="generic-modal-root">

    <button [disabled]="emailState > 0" (click)="resendIntroductionEmail()" class="btn btn-success modal-btn">{{emailStates[emailState]}}</button>

    <button (click)="close()" class="btn btn-danger modal-btn" >Cancel</button>
  
</div>